jQuery( document ).ready(function($) {
    console.log( "custom js" );

  if ($('.announcement-bar__message').length)  {
      $('.announcement-bar__message').marquee({
      	//duration in milliseconds of the marquee
      	duration: 12000,
      	//gap in pixels between the tickers
      	gap: 50,
      	//time in milliseconds before the marquee will start animating
      	delayBeforeStart: 0,
      	//'left' or 'right'
      	direction: 'left',
      	//true or false - should the marquee be duplicated to show an effect of continues flow
      	duplicated: true,
        
      });
  }
            $(".slider_first_video").click(function() {
                console.log('play video');
              
                //$("button.deferred-media__poster").trigger("click");
              /*
                mediaId = $(this).data('media-id');
                console.log('play video', mediaId);
                const newImage = $("#template_" + mediaId);
                const parentData = newImage.parent();

                parentData.prepend(newImage);
                newImage.show();

                $(".slide-image").removeClass('active-thumb');
                $(".slide-image.slider_first_video").addClass('active-thumb');
              */

              
            });
   

});
